export interface Restaurant {
  id: string;
  name: string;
  slug: string;
  description: string;
  location: string;
  website: string;
  phone: string;
  email: string;
  cuisine: string[];
  priceRange: string;
  rating: number;
  reviewCount: number;
  established: number;
  seo: {
    domainAuthority: number;
    backlinks: number;
    organicKeywords: number;
    organicTraffic: number;
    positionAverage: number;
    visibilityScore: number;
  };
  geo: {
    googleMyBusiness: boolean;
    citations: number;
    reviews: number;
    localPackRankings: number;
  };
  keywords: {
    primary: string[];
    secondary: string[];
    longTail: string[];
  };
  competitors: string[];
}

export const restaurants: Record<string, Restaurant> = {
  '39v': {
    id: '39v',
    name: 'Le 39V',
    slug: '39v',
    description: 'Restaurant gastronomique rooftop avec vue panoramique sur la Tour Eiffel',
    location: 'Paris 8ème, France',
    website: 'https://le39v.com',
    phone: '+33 1 42 25 39 39',
    email: 'contact@le39v.com',
    cuisine: ['Française', 'Gastronomique', 'Moderne'],
    priceRange: '€€€€',
    rating: 4.6,
    reviewCount: 2847,
    established: 2015,
    seo: {
      domainAuthority: 45,
      backlinks: 1250,
      organicKeywords: 49, // Données réelles SEMrush
      organicTraffic: 21, // Données réelles SEMrush
      positionAverage: 12.5,
      visibilityScore: 78
    },
    geo: {
      googleMyBusiness: true,
      citations: 89,
      reviews: 2847,
      localPackRankings: 3
    },
    keywords: {
      primary: ['le 39v', 'le 39 v', '39v'], // Données réelles SEMrush
      secondary: ['restaurant 8ème', 'cuisine française paris', 'restaurant étoilé paris'],
      longTail: ['restaurant paris avec terrasse', 'restaurant paris vue tour eiffel', 'menu dégustation paris']
    },
    competitors: ['rvtrader.com', 'linkedin.com', 'arabianmoda.com', 'rvuniverse.com', 'rvusa.com'] // Données réelles SEMrush
  },
  'cafe-max': {
    id: 'cafe-max',
    name: 'Café Max',
    slug: 'cafe-max',
    description: 'Bistrot parisien et canaille - Haut lieu historique de la Résistance',
    location: '7 Av. de la Motte-Picquet, 75007 Paris',
    website: 'https://cafemax.fr',
    phone: '+33 1 47 05 57 66',
    email: 'bistrot@cafemax.fr',
    cuisine: ['Française', 'Bistrot', 'Traditionnel'],
    priceRange: '€€',
    rating: 4.6,
    reviewCount: 500,
    established: 1941,
    seo: {
      domainAuthority: 18, // Estimé d'après Woorank Score 45/100
      backlinks: 12, // Woorank: Backlinks Score = BAD
      organicKeywords: 79, // Données réelles SEMrush
      organicTraffic: 15, // Données réelles SEMrush: 14.76
      positionAverage: 48.59, // Données réelles SEMrush
      visibilityScore: 2.18 // Part de voix SEMrush
    },
    geo: {
      googleMyBusiness: true,
      citations: 45, // Estimé
      reviews: 500, // Données réelles
      localPackRankings: 14 // SEMrush: 14 mots-clés en local pack
    },
    keywords: {
      primary: ['café max', 'cafe max invalides', 'max cafes'], // Données réelles SEMrush
      secondary: ['bistrot invalides', 'restaurant 7ème', 'café mäx'],
      longTail: ['photos de café max invalides', 'cafeteria max', 'café de max']
    },
    competitors: ['La Fontaine de Mars', 'Le Recrutement Café', 'Chez Françoise']
  },
  'fontaine-gaillon': {
    id: 'fontaine-gaillon',
    name: 'La Fontaine Gaillon',
    slug: 'fontaine-gaillon',
    description: 'Institution gastronomique parisienne fondée en 1802, réinventée par le Fitz Group. Terrasse néo-classique unique, salons privés historiques et cuisine bourgeoise contemporaine.',
    location: '1 Rue de la Michodière, 75002 Paris',
    website: 'https://www.fitz-group.fr/fontaine-gaillon-paris',
    phone: '+33 1 47 42 63 22',
    email: 'contact@fitz-group.fr',
    cuisine: ['Française', 'Gastronomique', 'Bourgeoise Contemporaine'],
    priceRange: '€€€€',
    rating: 4.5, // Note Google réelle
    reviewCount: 1250, // Estimé
    established: 1802,
    seo: {
      domainAuthority: 35, // Estimé (sous-domaine Fitz Group)
      backlinks: 450, // Estimé d'après couverture presse
      organicKeywords: 120, // À confirmer avec SEMrush
      organicTraffic: 85, // Estimé
      positionAverage: 18.5,
      visibilityScore: 62 // Autorité institutionnelle
    },
    geo: {
      googleMyBusiness: true,
      citations: 78, // Présence forte (Gault&Millau, guides)
      reviews: 1250,
      localPackRankings: 5 // Bon positionnement quartier Opéra
    },
    keywords: {
      primary: ['fontaine gaillon', 'la fontaine gaillon', 'restaurant fontaine gaillon'],
      secondary: ['restaurant terrasse paris 2', 'salon privé paris', 'restaurant historique paris', 'manoir urbain paris'],
      longTail: ['restaurant terrasse néoclassique paris', 'privatisation restaurant paris opéra', 'dîner d\'affaires terrasse paris', 'restaurant gastronomique place gaillon']
    },
    competitors: ['Drouant', 'Le Grand Colbert', 'Café de la Paix', 'Lasserre', 'Lucas Carton']
  },
  'hollywood-savoy': {
    id: 'hollywood-savoy',
    name: 'Hollywood Savoy',
    slug: 'hollywood-savoy',
    description: 'Renaissance iconique du temple festif des années 80. Fusion unique de gastronomie raffinée (Tomahawk, Caviar) et ambiance clubbing avec Live Shows. L\'adresse où la fête rencontre le luxe.',
    location: '44 Rue Notre Dame des Victoires, 75002 Paris',
    website: 'https://www.fitz-group.fr/hollywood-savoy-paris',
    phone: '+33 1 40 41 49 59',
    email: 'contact@fitz-group.fr',
    cuisine: ['Française', 'Fun Dining', 'Festive'],
    priceRange: '€€€',
    rating: 4.0, // Moyenne entre 3.9-4.2
    reviewCount: 850, // Estimé
    established: 1982, // Création originale années 80, rouverture 2024
    seo: {
      domainAuthority: 35, // Estimé (sous-domaine Fitz Group)
      backlinks: 680, // Forte couverture presse récente (Vogue, Sortiraparis)
      organicKeywords: 95, // À confirmer avec SEMrush
      organicTraffic: 140, // Buzz important 2024-2025
      positionAverage: 22.3,
      visibilityScore: 58 // Query Deserves Freshness fort
    },
    geo: {
      googleMyBusiness: true,
      citations: 62, // Croissance rapide
      reviews: 850,
      localPackRankings: 8 // Segment "Festif" très concurrentiel
    },
    keywords: {
      primary: ['hollywood savoy', 'savoy paris', 'hollywood savoy club'],
      secondary: ['restaurant festif paris', 'dîner clubbing paris', 'restaurant années 80 paris', 'restaurant bourse paris'],
      longTail: ['restaurant ambiance festive paris 2', 'dîner avec live show paris', 'restaurant club paris', 'soirée restaurant dansant paris', 'tomahawk restaurant paris']
    },
    competitors: ['Le Diner Festif', 'Daroco', 'Silencio', 'Alcazar', 'Le Bœuf sur le Toit', 'Paillettes']
  },
  'le-president': {
    id: 'le-president',
    name: 'Le Président',
    slug: 'le-president',
    description: 'Restaurant gastronomique lyonnais situé dans le prestigieux 6ème arrondissement de Lyon.',
    location: '11 Av. de Grande Bretagne, 69006 Lyon',
    website: 'https://restaurantlepresident.com',
    phone: '+33 4 78 24 33 34',
    email: 'contact@restaurantlepresident.com',
    cuisine: ['Française', 'Gastronomique', 'Lyonnaise'],
    priceRange: '€€€',
    rating: 4.3,
    reviewCount: 450,
    established: 1985,
    seo: {
      domainAuthority: 28,
      backlinks: 250,
      organicKeywords: 87,
      organicTraffic: 3150, // 3.15K visites/mois SEMrush
      positionAverage: 24.5,
      visibilityScore: 26 // AI Visibility SEMrush
    },
    geo: {
      googleMyBusiness: true,
      citations: 43, // Nombre de mentions IA
      reviews: 450,
      localPackRankings: 4
    },
    keywords: {
      primary: ['le président lyon', 'restaurant le président', 'président lyon 6'],
      secondary: ['restaurant lyon 6', 'restaurant gastronomique lyon', 'restaurant grande bretagne lyon'],
      longTail: ['restaurant gastronomique lyon 6ème', 'chefs et cuisiniers à lyon', 'restaurant lyon foch']
    },
    competitors: ['Têtedoie', 'Le Gourmet de Sèze', 'Daniel & Denise', 'Le Passe Temps', 'Pierre Orsi']
  }
};

export const getRestaurantById = (id: string): Restaurant | undefined => {
  return restaurants[id];
};

export const getAllRestaurants = (): Restaurant[] => {
  return Object.values(restaurants);
};
